import React from 'react';

export const renderError = (errors, idx, key, name) => {
  return (
    !!errors[key] &&
    !!errors[key].length &&
    !!errors[key][idx] &&
    !!errors[key][idx][name] && <p className="error">{errors[key][idx][name]}</p>
  );
};

export const hasError = (errors, idx, key, name) => {
  return !!(errors[key] && errors[key].length && errors[key][idx] && errors[key][idx][name]);
};



// WEBPACK FOOTER //
// ./src/utils/formikValidation.js